import Vue from "vue";
import VueRouter from "vue-router";
import MapApp from "../MapApp.vue";
import Login from "../Login.vue";
import { getToken } from "../utils/auth";

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
  if (!getToken("api_token")) {
    next();
    return;
  }

  next("/");
};

const ifAuthenticated = (to, from, next) => {
  if (getToken("api_token")) {
    next();
    return;
  }

  next("/login");
};

const routes = [
  {
    path: "/",
    name: "MapApp",
    component: MapApp,
    beforeEnter: ifAuthenticated
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    beforeEnter: ifNotAuthenticated
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
